// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width: 768px) {\nspan[data-v-cafa8672],\n  p[data-v-cafa8672] {\n    font-size: 12px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
